export default __webpack_public_path__ + "static/schneidersladen-eac3c4708914f4fd1067b4acf1230dfd.png";